export class TokenIterator {

    constructor(tokens) {
        this.tokens = tokens
        this.index = 0
    }

    token() {
        return this.tokens[this.index]
    }

    eatTokens(numberOfToken) {
        this.index += numberOfToken
    }

    hasNext(number) {
        return this.tokens.length >= this.index + number
    }

    peekNext(number) {
        return this.tokens[this.index + number]
    }

    isFirst() {
        return this.index === 0;
    }

    isLast() {
        return this.index === this.tokens.length - 1;
    }

}